/**
 * If want to use message sprites translated to Korean,
 * execute this script before executing main.js (more precisely, before creating PikachuVolleyball object).
 */

import { ASSETS_PATH } from '../resources/js/assets_path.js';

const TEXTURES = ASSETS_PATH.TEXTURES;

TEXTURES.MARK = 'messages/ko/mark.png';
TEXTURES.POKEMON = 'messages/ko/pokemon.png';
TEXTURES.PIKACHU_VOLLEYBALL = 'messages/ko/pikachu_volleyball.png';
TEXTURES.FIGHT = 'messages/ko/fight.png';
TEXTURES.WITH_COMPUTER = 'messages/ko/with_computer.png';
TEXTURES.WITH_FRIEND = 'messages/ko/with_friend.png';
TEXTURES.GAME_START = 'messages/ko/game_start.png';
